import React, { useMemo } from 'react';

const PanelHeading = ({
  className,
  children,
  current,
  expanded,
  onToggle,
  eventKey,
  onChange,
  defaultActiveKey,
  ...props
}) => {
  const subComponents = useMemo(() => {
    if (!children) return children;
    else if (Array.isArray(children)) {
      return children.map(child => {
        if (!child) return child;
        const clonedChild = {
          ...child,
          props: {
            expanded: expanded || current === eventKey,
            ...child?.props,
          },
        };
        return clonedChild;
      });
    } else if (children && typeof children === 'object') {
      return {
        ...children,
        props: { expanded: expanded || current === eventKey, ...children?.props },
      };
    }
    return children;
  }, [children, props]);
  return (
    <div
      className={`panel-heading ${className || ''}`}
      onClick={() => {
        if (onToggle) onToggle();
        else onChange(current !== eventKey ? eventKey : '');
      }}
      {...props}
    >
      {subComponents}
    </div>
  );
};

export default PanelHeading;
